import { IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { star, newspaper, heart, trendingUp, time } from 'ionicons/icons';
import { ContentInfo, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const ExploreEmptyContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate }) => {
    
    const router = useIonRouter();

    return (
        <div className="explore-empty-content">
            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
            <div className="ion-margin">{ GetStr(LANGUAGE.TXT_EXPLORE_NO_CONTENT) }</div>
            <div className="ion-text-center">
                <IonChip className="cat-but" onClick={()=> onUpdate(0, content)} >
                    <IonIcon icon={star} color="dark"/>&nbsp;&nbsp;
                    <IonLabel>{ GetStr(LANGUAGE.TXT_CAT_POPULAR) }</IonLabel>
                </IonChip>
            </div>
            <div className="ion-text-center">
                <IonChip className="cat-but" onClick={()=> onUpdate(1, content)}>
                    <IonIcon icon={newspaper} color="dark"/>&nbsp;&nbsp;
                    <IonLabel>{ GetStr(LANGUAGE.TXT_CAT_NEWS) }</IonLabel>
                </IonChip>
            </div>
            <div className="ion-text-center">
                <IonChip className="cat-but" onClick={()=> onUpdate(2, content)}>
                    <IonIcon icon={trendingUp} color="dark"/>&nbsp;&nbsp;
                    <IonLabel>{ GetStr(LANGUAGE.TXT_CAT_TRENDING) }</IonLabel>
                </IonChip>
            </div>
            <div className="ion-text-center ion-margin-bottom">
                <IonChip className="cat-but" onClick={()=> onUpdate(3, content)}>
                    <IonIcon icon={time} color="dark"/>&nbsp;&nbsp;
                    <IonLabel>{ GetStr(LANGUAGE.TXT_CAT_LATEST) }</IonLabel>
                </IonChip>
            </div>
        </div>
    );
};
  
export default ExploreEmptyContent;